import { render } from "./px-avatar-grid.vue?vue&type=template&id=15335689&scoped=true&ts=true"
import script from "./px-avatar-grid.vue?vue&type=script&lang=ts"
export * from "./px-avatar-grid.vue?vue&type=script&lang=ts"

import "./px-avatar-grid.vue?vue&type=style&index=0&id=15335689&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15335689"]])

export default __exports__